import { api } from "../api";

export async function getPlanEnteteById(idPlanEntete) {
  return await api.get(`planentete/getDescription/${idPlanEntete}`);
}